interface ToastProps {
  message: string | null;
}

export function Toast({ message }: ToastProps) {
  return (
    <div className="toast-slot" aria-live="polite">
      {message && <div className="toast">{message}</div>}
    </div>
  );
}
